import { UserType } from "../../../graphql/types";

export const CHAMBER_STAFF_COGNITO_GROUP = "CHAMBER_STAFF";

const existingAdminConsoleUserTypes = Object.values(UserType) as string[];

export const getSingleCognitoUserTypeFromGroups = (
  rawGroups: unknown
): UserType | "" => {
  if (!Array.isArray(rawGroups) || rawGroups.length !== 1) {
    return "";
  }

  const [group] = rawGroups;
  if (
    typeof group !== "string" ||
    !existingAdminConsoleUserTypes.includes(group)
  ) {
    return "";
  }

  return group as UserType;
};

/**
 * The legacy Chamber Perks dashboard only has a ChamberAdmin UI role.
 * Authorization for chamber staff remains a backend responsibility; this
 * adapter only lets an already-authorized staff session reuse that UI.
 */
export const getAdminConsoleUserTypeFromCognitoGroups = (
  rawGroups: unknown
): UserType | "" => {
  const rawUserType = getSingleCognitoUserTypeFromGroups(rawGroups);

  if (rawUserType === CHAMBER_STAFF_COGNITO_GROUP) {
    return UserType.ChamberAdmin;
  }

  if (
    typeof rawUserType === "string" &&
    existingAdminConsoleUserTypes.includes(rawUserType)
  ) {
    return rawUserType as UserType;
  }

  return "";
};
